export class MyDocApprovalsConstants{
    public static readonly MyDocApprovals_TopBarTitle: string = 'My Doc Approvals';
    public static readonly MyDocApprovals_CheckBoxHoverToolTip: string = 'By default only Ready for Approval Document Versions with your Pending Approvals are displayed. Check this check box to display all the Document Version where you are assigned as Approver, regardless of any other condition.';
    public static readonly MyDocApprovals_ShowAllLabel: string = 'Show All';
    public static readonly MyDocApprovals_ShowInformationIconCheckbox: boolean = true;
    public static readonly MyDocApprovals_IsIncludeAll: boolean = false;
}
